// extracted by mini-css-extract-plugin
module.exports = {"burgerIcon":"y-","cross":"y_","iconSVGWrapper":"za","iconSVG":"zb","iconSVGDark":"zc"};